import { getTenant } from '@/config/axios/config'
export function loadModuleBasedOnCondition() {
    let tenant = getTenant()
    if (tenant.tenant_id === 154) {
        import('@/common/theme_cy.scss');
    } else if (tenant.tenant_id === 155) {
        import('@/common/theme_sj.scss');
    }
}